import { usePostOfficeUserInteractions } from '@atlassian/post-office-analytics/interactions';

// eslint-disable-next-line @atlaskit/design-system/use-spotlight-package
import Spotlight from '@atlaskit/onboarding/spotlight';

import { token } from '@atlaskit/tokens';

import { useFirePostOfficeTrigger } from '@atlassian/post-office-context/post-office-trigger';

import { useCallback } from 'react';

import { useIntl } from 'react-intl';

import { messages } from './messages';

import { type JSX } from 'react/jsx-runtime';

export const DetailViewSpotlight = ({
	setNextStep,
	onDismissed,
	illustration,
}: {
	setNextStep: () => void;
	onDismissed: () => void;
	illustration: string;
}): JSX.Element => {
	const { formatMessage } = useIntl();
	const { onCtaActioned } = usePostOfficeUserInteractions();
	const { fireTrigger } = useFirePostOfficeTrigger({
		triggerId: 'jira-nin-list-merge-modal-onboarding-explore-list-clicked',
	});

	const handleNext = useCallback(() => {
		void onCtaActioned({ interactionIdentifier: 'exploreListView' });
		setNextStep();
		fireTrigger({ isActive: true });
	}, [fireTrigger, setNextStep, onCtaActioned]);

	return (
		<Spotlight
			actions={[
				{
					onClick: handleNext,
					text: formatMessage(messages.exploreListViewButtonLabel),
				},
				{
					onClick: onDismissed,
					text: formatMessage(messages.listMergeSpotlightDismiss),
					appearance: 'subtle',
				},
			]}
			heading={formatMessage(messages.listMergeSpotlightHeading)}
			target="project-issue-navigator.ui.page-actions.view-switcher"
			key="project-issue-navigator.ui.page-actions.view-switcher"
			targetBgColor={token('elevation.surface')}
			targetRadius={token('radius.medium', '3px')}
			dialogWidth={275}
			image={illustration}
			testId="list-merge-spotlight"
			dialogPlacement="left top"
		>
			{formatMessage(messages.listMergeSpotlightBody)}
		</Spotlight>
	);
};
